import { ISagaCb } from '@typings/requestPayloads'
import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface ISuggestMeetingRequestByIDPayload extends ISagaCb {
    requestId: string
    data: {
        suggestedTime: any
    }
}

export interface ISuggestMeetingRequestByIDState {
    status: string
    data: any
    errors: any
}

const initialState: ISuggestMeetingRequestByIDState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const suggestMeetingRequestByID = createSlice({
    name: 'meeting-requests/suggest-by-id',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<ISuggestMeetingRequestByIDPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const suggestMeetingRequestByIDActions = suggestMeetingRequestByID.actions
export default suggestMeetingRequestByID.reducer
